export default __webpack_public_path__ + "static/cloud-page-be74c002336a9ec0d36fd8861b356f8f.jpg";